import React from "react";
import { useSelector } from "react-redux";
import CustomButton from "../../components/Buttons/CustomButton";

const DownloadButton = ({
  action,
  hyperlink,
  hyperlink_title,
  download_title,
  resourceType,
  userType,
  handleLoginModal,
  downloadURL,
  setProUpgradeModal,
  setPremiumUpgradeModal,
  recentActivity,
  id,
}) => {
  const user_info = useSelector((state) => state?.my_account?.user_info);
  const typeRank = {
    BASIC: 1,
    PREMIUM_MONTH: 2,
    PREMIUM: 2,
    PRO_MONTH: 3,
    PRO: 3,
  };

  const title = action ? hyperlink_title : download_title || "Download This Resource";
  const linkText =  title;

  if (userType === "BASIC" && resourceType === "PREMIUM") {
    return (
      <CustomButton variant="primary" onClick={() => setPremiumUpgradeModal(true)}>
        {linkText}
      </CustomButton>
    );
  }

  if ((userType === "BASIC" && resourceType === "PRO") || (userType === "PREMIUM" && resourceType === "PRO")) {
    return (
      <CustomButton variant="primary" onClick={() => setProUpgradeModal(true)}>
        {linkText}
      </CustomButton>
    );
  }

  if (!user_info?.auth_token) {
    return (
      <CustomButton variant="primary" onClick={handleLoginModal}>
        {linkText}
      </CustomButton>
    );
  }

  if (typeRank[resourceType] <= typeRank[userType]) {
    return (
      <a
        href={!action ? downloadURL : hyperlink}
        target="_blank"
        download={!action}
        rel="noreferrer"
        onClick={() => {
          if (downloadURL) {
            recentActivity("download", null, id);
          }
        }}
      >
        <CustomButton variant="primary">
        {linkText}
        </CustomButton>
      </a>
    );
  }

  return (
    // <NavLink to="/membership" className="joinBtn d-none d-md-flex">
    //   {linkText}
    // </NavLink>
    <div onClick={() => setProUpgradeModal(true)}>{linkText}</div>
  );
};

export default DownloadButton;
